<template>
  <aside v-show="isVisible" class="soulody lets-talk">
    <div class="close cursor-pointer" @click="hide">
      <img :src="$asset('homepage/img/icons/cross.svg')" alt="" />
    </div>
    <img :src="personaSrc" :alt="$t('homepage.contact.persona.name')" />

    <p class="caption text-black-darker">{{ $t('homepage.contact.persona.name') }}</p>
    <label class="text-black-darker">{{ $t('homepage.contact.persona.subtitle') }}</label>
    <span
      class="heading-7 text-black-darker"
      v-html="addNbsp($t('homepage.contact.letsTalk.heading'))"
    />
    <a
      href="#contact"
      class="text--primary heading-7"
      @click.stop="
        gtmPush({
          event: 'button_click',
          link_text: $t('homepage.contact.letsTalk.link'),
          link_location: 'floating-kontakt'
        })
      "
    >
      {{ $t('homepage.contact.letsTalk.link') }}
    </a>
  </aside>
</template>

<script>
export default {
  name: 'LetsTalkComponent',
  data() {
    return {
      isVisible: true
    };
  },
  computed: {
    personaSrc() {
      return this.$asset(`homepage/img/personas/${this.$t('homepage.contact.persona.img')}`);
    }
  },
  methods: {
    hide() {
      this.isVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
aside.lets-talk {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  bottom: 16px;
  right: 16px;
  width: 204px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  z-index: 999;

  .cursor-pointer {
    cursor: pointer;
  }

  & > * {
    margin: 0;
    padding: 0;
    font-family: 'Pangram', 'Sen', sans-serif;
    font-weight: 700;
    box-sizing: border-box;
  }

  .text-black-darker {
    color: #141414;
  }

  label {
    letter-spacing: 0.28px;
    width: auto;
  }

  h6,
  label {
    font-size: 14px;
    line-height: 21px;
  }

  .heading-7 {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.24px;
  }

  .text--primary {
    color: #3ca091 !important;
  }

  @media screen and (max-width: 930px) {
    display: none;
  }

  > div {
    position: absolute;
    background-color: white;
    padding: 8px;
    border-radius: 8px;
    right: 8px;
    top: 8px;
    height: 40px;
  }

  > img {
    max-width: 88px;
  }

  > .caption {
    margin-top: 8px;
    margin-bottom: 0;
    font-size: 12px;
    line-height: 13.2px;
    letter-spacing: 0.96px;
    text-transform: uppercase;
  }

  > label {
    margin-top: 4px;
  }

  > span {
    margin-top: 16px;
  }

  > a {
    margin: 16px 0;
    font-weight: 600;
    text-decoration: none;
  }
}
</style>
